import type { FC } from 'react';

import { useLinkComponent } from '@eneco/link';
import { ButtonLink, NavLink, Stack } from '@eneco/sparky';
import { useI18nTranslation } from '@eneco/sparky/providers';
import { MainMenuRendering, MainMenuRightRendering } from '@sitecore/types/manual/NavigationBar';

import { usePlaceholderComponentContent } from '../hooks/usePlaceholderComponentContent';

const MainMenu: FC = function () {
  const mainNavigation = useI18nTranslation('mainNavigation');
  const Link = useLinkComponent();
  const content = usePlaceholderComponentContent<MainMenuRendering>('jss-main-navigation-left', 'MainMenu');
  const buttonLink = usePlaceholderComponentContent<MainMenuRightRendering>(
    'jss-main-navigation-right',
    'BecomeACustomer',
  );

  if (!content?.fields.items) return null;

  return (
    <nav aria-label={mainNavigation}>
      <Stack as="ul" direction={{ initial: 'column', lg: 'row' }} gap={{ initial: '6', lg: '4' }}>
        {content.fields.items.map(item => (
          <li key={item.id}>
            <Link href={item.fields.link.value.href} linkType={item.fields.link.value.linktype}>
              <NavLink variant="secondary">{item.fields.link.value.text}</NavLink>
            </Link>
          </li>
        ))}
        {buttonLink ? (
          <ButtonLink action="secondary" size="compact" href={buttonLink.fields.link.value.href}>
            {buttonLink.fields.link.value.text}
          </ButtonLink>
        ) : null}
      </Stack>
    </nav>
  );
};

export default MainMenu;
